<template>
  <NuxtLink
    v-if="bike"
    class="bg-white flex justify-between items-center no-underline text-dark"
    :to="getLink(bike)"
    target="_blank"
  >
    <span class="flex items-center">
      <img class="h-[70px]" :src="createImageUrl(bike)" aria-hidden="true" />
      <span class="font-bold">{{ bike.name }}</span>
    </span>
    <span class="flex items-center pr-4">
      <img
        v-if="bike.battery"
        src="/map/shared/battery.svg"
        aria-hidden="true"
      />
      <span class="pr-4">{{ bike.number }}</span>
      <DbcSvg class="text-primary" name="dbc-navigation-link"></DbcSvg>
    </span>
  </NuxtLink>
</template>

<script setup lang="ts">
defineProps<{
  bike: AvailableBike | null
}>()

const createImageUrl = (bike: AvailableBike) => {
  const provider = getProvider(bike.provider)

  let image
  switch (bike.type) {
    case 'PEDELEC':
      image = 'pedelec-illustration.svg'
      break
    case 'CARGOPEDELEC':
      image = 'cargo-illustration.svg'
      break
    case 'UNKNOWN':
      image = 'jimi.svg'
      break
    default:
      image = `${bike.lockType.toLowerCase()}.svg`
  }

  return `/map/${provider}/${image}`
}

const clientBaseUrlMapping = useRuntimeConfig().public
  .clientBaseUrlMapping as ClientBaseUrlMapping

const getLink = (bike: AvailableBike) => {
  const provider = getProvider(bike.provider)
  const domain = clientBaseUrlMapping[provider]
  const path = `/qrcode/bike?number=${bike.number}`
  return domain + path
}
</script>
